import { NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";

export const NavButton = ({ children, ...props }) => (
  <Nav.Link
    as={NavLink}
    className={({ isActive, isPending, isTransitioning }) =>
      [
        isPending ? "pending" : "",
        isActive ? "navActive" : "",
        isTransitioning ? "transitioning" : "",
      ].join(" ")
    }
    {...props}
  >
    {children}
  </Nav.Link>
);
